import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {nameSegmentToIdentifier} from '#/lib/strings/profile-path'
import {makeRecordUri} from '#/lib/strings/url-helpers'
import {ViewHeader} from '#/view/com/util/ViewHeader'
import * as Layout from '#/components/Layout'
import {LikedByList} from '#/components/LikedByList'

export function ProfileLabelerLikedByScreen({
  route,
}:
  | NativeStackScreenProps<CommonNavigatorParams, 'ProfileLabelerLikedBy'>
  | NativeStackScreenProps<
      CommonNavigatorParams,
      'ProfileByNameLabelerLikedBy'
    >) {
  const handleOrDid =
    route.name === 'ProfileByNameLabelerLikedBy'
      ? // AtUri throws synchronously on an empty/malformed host, so an
        // unresolvable segment falls back to the same sentinel
        // isInvalidHandle() already recognizes, rather than '' - the
        // resulting failed resolution is handled the same way any other
        // nonexistent handle already is.
        (nameSegmentToIdentifier(route.params.name) ?? 'handle.invalid')
      : route.params.name
  const uri = makeRecordUri(handleOrDid, 'app.bsky.labeler.service', 'self')
  const {_} = useLingui()

  return (
    <Layout.Screen>
      <ViewHeader title={_(msg`Liked By`)} />
      <LikedByList uri={uri} />
    </Layout.Screen>
  )
}
